import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Button,
  CircularProgress,
} from "@mui/material";

import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { cl } from "./styles";
import { ArrowDown } from "Icons/ArrowDown";
import { ChatContext } from "../ActiveChat";
import { ANALYSES_TYPES } from "constants/common.constants";
import { getGraphTitle, sortingByNotNullFirst } from "helpers/common";

const ROUTE_KEYS_TYPES = [
  ANALYSES_TYPES.MULTIVARIATE_SINGLE,
  ANALYSES_TYPES.MIXED_MODEL_SINGLE,
  ANALYSES_TYPES.TREE_ANALYSIS,
];

export const AnalyseGraph = ({ data, currentAnalyse, routeKey, setHasNotCreatedGraphs, graphLoading }) => {
  const [graphs, setGraphs] = useState([]);
  const { onOpenEditGraph } = useContext(ChatContext);

  useEffect(() => {
    if (!data || !Object.keys(data)?.length) return;

    const sortedGraphs = sortingByNotNullFirst(data);
    setGraphs(sortedGraphs);

    const filteredValues = Object.values(data);
    if (filteredValues?.includes(null)) setHasNotCreatedGraphs(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <>
      {graphs.map((graph, index) => (
        <Accordion key={index} defaultExpanded={!index} sx={cl.accordion} PaperProps={cl.accordionPaper}>
          <AccordionSummary expandIcon={<ArrowDown />} sx={cl.accordionSummary}>
            <Typography>{getGraphTitle(graph, routeKey)}</Typography>
          </AccordionSummary>
          <AccordionDetails sx={cl.accordionDetails}>
            <Box sx={cl.accordionIcon}>
              {graphLoading && data[graph] === null ? (
                <CircularProgress size={30} />
              ) : (
                <img style={{ width: "100%" }} src={data[graph]} alt="graph" />
              )}
            </Box>

            <Button
              sx={cl.editBtn}
              variant="contained"
              size="small"
              startIcon={<ModeEditIcon />}
              onFocus={(event) => event.stopPropagation()}
              onClick={(e) => {
                if (ROUTE_KEYS_TYPES.includes(currentAnalyse.analysis_type))
                  return onOpenEditGraph(e, ["all", routeKey], currentAnalyse);
                if (routeKey) return onOpenEditGraph(e, ["all", routeKey, graph], currentAnalyse);
                return onOpenEditGraph(e, ["all", graph], currentAnalyse);
              }}
            >
              Edit
            </Button>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};
